import * as React from "react"
import { useState, Fragment } from "react"
import { PieChart } from 'react-minimal-pie-chart';
import "./style_2.scss"
import { PRODUCT_TYPE_WATER } from "../../constants";

export default function ProductContentStyle2({ items, selectedType }) {
    const [expanded, setExpanded] = useState({
        carbon: {},
        water: {},
    });

    const chartData = items?.find(item => item.title === selectedType)
        ?.info_progress.map(item => {
            return {
                title: item.title,
                value: +item.progress,
                color: item.colour,
            }
        })

    const formatDecimals = (value) => {
        const str = value.toString();
        const decimalIndex = str.indexOf('.');

        if (decimalIndex === -1) {
            return value;
        }

        const decimalPlaces = str.length - decimalIndex - 1;
        return decimalPlaces > 2 ? Number(value).toFixed(2) : value;
    };

    return (items?.map((data, index) => {
        const progressCheck = data.info_progress?.every(item => !Number(item.progress));

        return (!!Object.keys(data)?.length && !!Number(data.info_data.count) && !progressCheck && (
            <div key={index} className={`product-content style_2`}>
                {selectedType === data.title && (
                    <>
                        <div className="chart">
                            <PieChart
                                data={chartData}
                                lineWidth={15}
                            />

                            {data?.info_data && (
                                <div className="info-data">
                                    {data?.info_data?.count &&
                                        <p className="info-count">{data?.info_data?.count}</p>
                                    }

                                    <p className="info-unit">
                                        <span>
                                            {selectedType === PRODUCT_TYPE_WATER && !data?.info_data?.unit
                                                ? 'Litres'
                                                : data?.info_data?.unit}
                                        </span>
                                        {data?.info_data?.element &&
                                            <span>{data?.info_data?.element}</span>
                                        }
                                    </p>
                                </div>
                            )}
                        </div>

                        {!!data?.info_progress?.length && (
                            <div className="list">
                                {data?.info_progress?.sort((a, b) => +b.progress - +a.progress)?.map((progressItem, index) => (
                                    <Fragment key={index}>
                                        {!!Number(progressItem.progress) && (
                                            <div className="progress-item">
                                                <div className="progress-info">
                                                    <p className="title"
                                                        onClick={() => setExpanded(prev => ({
                                                            ...prev,
                                                            [selectedType]: {
                                                                ...expanded[selectedType],
                                                                [index]: !expanded[selectedType]?.[index]
                                                            }
                                                        }))}
                                                    >
                                                        <span className={`progress-bullet`} style={{backgroundColor: `${progressItem.colour}`}}></span>
                                                        <span className="progress-title">{progressItem.title}</span>
                                                        <span className={`progress-arrow ${!expanded[selectedType]?.[index] ? 'expanded' : ''}`}><img src={"/static/images/product-arrow.svg"} alt="" /></span>
                                                    </p>
                                                    <div className="value">{formatDecimals(progressItem.progress)}%</div>
                                                </div>

                                                <p className={`description ${!expanded[selectedType]?.[index] ? '' : 'expanded'}`}>{progressItem.description}</p>
                                            </div>
                                        )}
                                    </Fragment>
                                ))}
                            </div>
                        )}

                        {!!data?.info_content && (
                            <div className="info-content">
                                <div>
                                    <p className="info-title">{data?.info_content?.title}</p>
                                    <img className="info-image" src={data?.info_content?.index_icon} alt="" />
                                </div>
                                <p className="info-description">{data?.info_content?.description}</p>
                            </div>
                        )}
                    </>
                )}
                {
                    data?.style === 'default' && (
                        <div className="info">
                            <div>
                                <p className="info-title">{data?.title}</p>
                                <img className="info-image" src={data?.icon} alt="" />
                            </div>
                            <p className="info-description">{data?.description}</p>
                        </div>
                    )
                }
            </div>
        ))
    }
    )
    )
}
